var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-1 mt-3",attrs:{"headers":_vm.route_headers,"items":_vm.route_items,"loading-text":"Загружаю данные","dense":"","footer-props":{
    itemsPerPageText: 'На страницу',
    itemsPerPageAllText: 'Все',
    pageText: 'из'
  }},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-system-bar',{attrs:{"color":"primary","dark":""}},[_c('span',{staticClass:"white--text"},[_vm._v("История состояний:")])])]},proxy:true},{key:"no-data",fn:function(){return [_vm._v(" Нет данных ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }